import { ReactNode, useState } from "react";
import { HiCheck } from "react-icons/hi";
import { RiSubtractFill } from "react-icons/ri";
import styles from "./MeritoCheckbox.module.scss";

type CheckedState = "yes" | "no" | "partial";
type Size = "md1" | "md2";
type State = "default" | "disabled" | "hover" | "focus";

type Props = {
  checked?: CheckedState;
  size?: Size;
  state?: State;
  label?: ReactNode;
  onChange?: (checked: CheckedState) => void;
};

const MeritoCheckbox = ({ checked: checkedProp, size = "md1", state = "default", label, onChange }: Props) => {
  const [internalChecked, setInternalChecked] = useState<CheckedState>(checkedProp ?? "no");

  const isControlled = checkedProp !== undefined;
  const checked = isControlled ? checkedProp : internalChecked;

  const handleClick = () => {
    if (state === "disabled") return;
    const next: CheckedState = checked === "yes" ? "no" : "yes";
    if (!isControlled) setInternalChecked(next);
    onChange?.(next);
  };

  return (
    <div
      className={`${styles.wrapper} ${styles[state]} ${styles[checked]}`}
      onClick={handleClick}
    >
      <div className={`${styles.checkbox} ${styles[size]} ${styles[state]} ${styles[checked]}`}>
        {checked === "yes" && <HiCheck />}
        {checked === "partial" && <RiSubtractFill />}
      </div>
      {label && <span className={styles.label}>{label}</span>}
    </div>
  );
};

export default MeritoCheckbox;
